<script setup lang="ts">
import { useI18n } from "vue-i18n";

import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import SelectableList from "@/components/ui/SelectableList/SelectableList.vue";

interface Item {
  id: string | number;
  name: string;
  description?: string;
}

const props = defineProps<{
  header?: string;
  modelValue?: Item | Item[];
  values: readonly Item[];
  translate?: boolean;
}>();

const emit = defineEmits<{ "update:model-value": [value: Item | Item[]] }>();

const { t } = useI18n();

function name(item: Item) {
  return props.translate ? t(item.name) : item.name;
}
</script>

<template>
  <SelectableList
    v-keyboard-nav
    :header
    :model-value
    :values
    @update:model-value="emit('update:model-value', $event)"
  >
    <template #default="{ item }">
      <BaseTooltip v-if="item.description" style="width: 100%">
        <template #content>
          {{ item.description }}
        </template>
        {{ name(item) }}
      </BaseTooltip>

      <span v-else>
        {{ name(item) }}
      </span>
    </template>
  </SelectableList>
</template>
